export default {
    "0": "Sunny", // 晴（国内城市白天晴）	
    "1": "Clear", //	晴（国内城市夜晚晴）	Clear
    "2": "Fair", //	晴（国外城市白天晴）	
    "3": "Fair", // 	晴（国外城市夜晚晴）	
    "4": "Cloudy", // 	多云	
    "5": "Partly Cloudy", // 	晴间多云	
    "6": "Partly Cloudy", // 	晴间多云	
    "7": "Mostly Cloudy", //	大部多云	
    "8": "Mostly Cloudy", //	大部多云	
    "9": "Overcast", //	阴	Overcast
    "10": "Shower", //	阵雨	
    "11": "Thundershower", //	雷阵雨	
    "12": "Thundershower with Hail", //	雷阵雨伴有冰雹	
    "13": "Light Rain", //	小雨	
    "14": "Moderate Rain", //	中雨	
    "15": "Heavy Rain", //	大雨	
    "16": "Storm", //	暴雨	
    "17": "Heavy Storm", //	大暴雨	
    "18": "Severe Storm", //	特大暴雨	
    "19": "Ice Rain", //	冻雨	
    "20": "Sleet", //	雨夹雪	
    "21": "Snow Flurry", //	阵雪	
    "22": "Light Snow", //	小雪	
    "23": "Moderate Snow", //	中雪	
    "24": "Heavy Snow", //	大雪	
    "25": "Snowstorm", //	暴雪	
    "26": "Dust", //	浮尘	
    "27": "Sand", //	扬沙	
    "28": "Duststorm", //	沙尘暴	
    "29": "Sandstorm", //	强沙尘暴	
    "30": "Foggy", //	雾	
    "31": "Haze", //	霾	
    "32": "Windy", //	风	
    "33": "Blustery", //	大风	
    "34": "Hurricane", //	飓风	
    "35": "Tropical Storm", //	热带风暴	
    "36": "Tornado", //	龙卷风	
    "37": "Cold", //	冷	
    "38": "Hot", //	热	
    "99": "Unknown", //	未知	
}